<template>
  <div class="text" :class="{
    'text--center': center,
  }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VText',
  props: {
    center: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-family: 'Anton', Arial, Helvetica, sans-serif;
  font-size: font(18px, 44px);
  line-height: 1.25em;
  text-transform: uppercase;
  color: #080808;

  &:not(:first-child) {
    margin-top: 25px;
  }
  
  u {
    text-decoration: none;

    background-image: url('~@/assets/underline.png');
    background-position: bottom center;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }

  a {
    color: #ff2128;
    text-decoration: none;

    border-bottom: 1px solid #ff2128;

    &:hover {
      color: #ffffff;
      border-bottom: 1px solid #ffffff;
    }
  }

  span {
    color: #ff2128;
  }

  big {
    font-size: font(18px, 70px);
    line-height: 1.25em;
  }

  small {
    font-size: font(12px, 40px);
    line-height: 1.25em;
  }

  &--center {
    text-align: center;
  }
}
</style>
